import {readingTime} from 'reading-time-estimator';

(() => {
    /**
     * Function to calculate the reading time for a given text.
     * @param {string} text - The text to estimate reading time for.
     */
    function getReadingTime(text) {
        const result = readingTime(text, 250);
        return result.minutes;
    }

    let divText = document.querySelector('#article-content')?.textContent;

    if (!divText) return;

    document.addEventListener("DOMContentLoaded", () => {
        let readTime = getReadingTime(divText);
        let readingTimeSpan = document.querySelector('p#reading-time');

        if (!readingTimeSpan) return;

        readingTimeSpan.innerHTML = readTime + " mins";
    });
})();
